import React from 'react';
import { rootStore } from '../stores/rootStore';

export const RootStoreContext = React.createContext(rootStore);